
<div class="p-1 text-center" dir="rtl">
  <h3 mat-dialog-title>هشدار!</h3>

  <div mat-dialog-content class="mt-2">
    <p>{{ data.message }}</p>
  </div>
  <div mat-dialog-actions>

    <button mat-button class="btn mt-2" style="background-color: rgb(148, 147, 147) !important;color: #fff;width:5rem;margin-left: 1rem;" (click)="onYesClick()" cdkFocusInitial>بلی</button>
    <button class="ml-2" class="btn border mt-2" style="width:4rem;;"  mat-button (click)="onNoClick()">خیر</button>
  </div>
</div>

